module.exports = __webpack_public_path__ + "img/pyq.de789886.png";